import React, { Component } from 'react'
import { MatomoContainer } from './Matomo'
import { GoogleAnalyticsContainer } from './GoogleAnalytics'

export class Analytics extends Component
{
    render()
    {
        return (
            <MatomoContainer>
                <GoogleAnalyticsContainer>
                    {this.props.children}
                </GoogleAnalyticsContainer>
            </MatomoContainer>
        )
    }
}
